export class EpisodeMedia {
    constructor(videoUrl: string, audioUrl: string) {
        this.videoUrl = videoUrl;
        this.audioUrl = audioUrl;
    }

    videoUrl: string;
    audioUrl: string;
}